import {
  API_RESPONSE_ERROR,
  API_RESPONSE_SUCCESS,
  CREATE_ACCOUNTS,
  DELETE_ACCOUNTS,
  GET_ACCOUNTS,
  GET_ACCOUNT_BY_ID,
  UPDATE_ACCOUNTS,
} from './actionType';

// common success
export const AccountsApiSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const AccountsApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const GetAccounts = () => ({
  type: GET_ACCOUNTS,
});

export const CreateAccounts = (data, history) => ({
  type: CREATE_ACCOUNTS,
  payload: { data, history },
});

export const UpdateAccounts = (id, data, history) => ({
  type: UPDATE_ACCOUNTS,
  payload: { id, data, history },
});

export const DeleteAccounts = (id) => ({
  type: DELETE_ACCOUNTS,
  payload: { id },
});

export const GetAccountById = (id) => ({
  type: GET_ACCOUNT_BY_ID,
  payload: { id },
});
